"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var UNSUPPORTED_METHODS = ['PUT', 'DELETE', 'PATCH'];
var CsrfForm = /** @class */ (function (_super) {
    tslib_1.__extends(CsrfForm, _super);
    function CsrfForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { token: '' };
        return _this;
    }
    CsrfForm.prototype.componentDidMount = function () {
        this.setState({
            token: this.csrfToken(),
        });
    };
    CsrfForm.prototype.csrfToken = function () {
        var csrfMetaTag = document.querySelector('meta[name=csrf-token]');
        if (csrfMetaTag) {
            return csrfMetaTag.content;
        }
        return '';
    };
    CsrfForm.prototype.unsupportedMethod = function () {
        return UNSUPPORTED_METHODS.indexOf(this.props.method.toUpperCase()) > -1;
    };
    CsrfForm.prototype.methodInput = function () {
        if (this.unsupportedMethod()) {
            return React.createElement("input", { type: "hidden", name: "_method", value: this.props.method });
        }
    };
    CsrfForm.prototype.method = function () {
        if (this.unsupportedMethod()) {
            return 'POST';
        }
        return this.props.method;
    };
    CsrfForm.prototype.render = function () {
        return (React.createElement("form", tslib_1.__assign({}, this.props, { method: this.method() }),
            React.createElement("input", { type: "hidden", name: "authenticity_token", value: this.state.token }),
            this.methodInput(),
            this.props.children));
    };
    return CsrfForm;
}(React.Component));
exports.default = CsrfForm;
//# sourceMappingURL=csrf_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/csrf_form.js
// module id = 2f3W
// module chunks = 20 21